/**
 * Generated file, do not edit directly!
 */

/** Typography establishes content hierarchy in your app, and is a key aspect of shaping its readability. It plays a crucial role in how your app looks, feels, and effectively communicates content to users. */

/** Use to visually strike top-level hierarchy, such as hero sections. */
const Display = {
  Level1: {
    /** Css custom property: --dt-typography-display-level-1-family. Default value: DynatraceFlow,Roboto,Helvetica,sans-serif. */
    Family:
      'var(--dt-typography-display-level-1-family, DynatraceFlow,Roboto,Helvetica,sans-serif)',
    /** Css custom property: --dt-typography-display-level-1-weight. Default value: 600. */
    Weight: 'var(--dt-typography-display-level-1-weight, 600)',
    /** Css custom property: --dt-typography-display-level-1-size. Default value: 64px. */
    Size: 'var(--dt-typography-display-level-1-size, 64px)',
    /** Css custom property: --dt-typography-display-level-1-line-height. Default value: 1.1875. */
    LineHeight: 'var(--dt-typography-display-level-1-line-height, 1.1875)',
    /** Css custom property: --dt-typography-display-level-1-text-decoration. Default value: none. */
    TextDecoration:
      'var(--dt-typography-display-level-1-text-decoration, none)',
    /** Css custom property: --dt-typography-display-level-1-text-transform. Default value: none. */
    TextTransform: 'var(--dt-typography-display-level-1-text-transform, none)',
  },
  Level2: {
    /** Css custom property: --dt-typography-display-level-2-family. Default value: DynatraceFlow,Roboto,Helvetica,sans-serif. */
    Family:
      'var(--dt-typography-display-level-2-family, DynatraceFlow,Roboto,Helvetica,sans-serif)',
    /** Css custom property: --dt-typography-display-level-2-weight. Default value: 600. */
    Weight: 'var(--dt-typography-display-level-2-weight, 600)',
    /** Css custom property: --dt-typography-display-level-2-size. Default value: 56px. */
    Size: 'var(--dt-typography-display-level-2-size, 56px)',
    /** Css custom property: --dt-typography-display-level-2-line-height. Default value: 1.2142857143. */
    LineHeight:
      'var(--dt-typography-display-level-2-line-height, 1.2142857143)',
    /** Css custom property: --dt-typography-display-level-2-text-decoration. Default value: none. */
    TextDecoration:
      'var(--dt-typography-display-level-2-text-decoration, none)',
    /** Css custom property: --dt-typography-display-level-2-text-transform. Default value: none. */
    TextTransform: 'var(--dt-typography-display-level-2-text-transform, none)',
  },
  Level3: {
    /** Css custom property: --dt-typography-display-level-3-family. Default value: DynatraceFlow,Roboto,Helvetica,sans-serif. */
    Family:
      'var(--dt-typography-display-level-3-family, DynatraceFlow,Roboto,Helvetica,sans-serif)',
    /** Css custom property: --dt-typography-display-level-3-weight. Default value: 600. */
    Weight: 'var(--dt-typography-display-level-3-weight, 600)',
    /** Css custom property: --dt-typography-display-level-3-size. Default value: 48px. */
    Size: 'var(--dt-typography-display-level-3-size, 48px)',
    /** Css custom property: --dt-typography-display-level-3-line-height. Default value: 1.25. */
    LineHeight: 'var(--dt-typography-display-level-3-line-height, 1.25)',
    /** Css custom property: --dt-typography-display-level-3-text-decoration. Default value: none. */
    TextDecoration:
      'var(--dt-typography-display-level-3-text-decoration, none)',
    /** Css custom property: --dt-typography-display-level-3-text-transform. Default value: none. */
    TextTransform: 'var(--dt-typography-display-level-3-text-transform, none)',
  },
};
/** Use to group content into sections. Different levels are used to indicate visual and structural hierarchy. */
const Heading = {
  Level1: {
    /** Css custom property: --dt-typography-heading-level-1-family. Default value: DynatraceFlow,Roboto,Helvetica,sans-serif. */
    Family:
      'var(--dt-typography-heading-level-1-family, DynatraceFlow,Roboto,Helvetica,sans-serif)',
    /** Css custom property: --dt-typography-heading-level-1-weight. Default value: 600. */
    Weight: 'var(--dt-typography-heading-level-1-weight, 600)',
    /** Css custom property: --dt-typography-heading-level-1-size. Default value: 32px. */
    Size: 'var(--dt-typography-heading-level-1-size, 32px)',
    /** Css custom property: --dt-typography-heading-level-1-line-height. Default value: 1.25. */
    LineHeight: 'var(--dt-typography-heading-level-1-line-height, 1.25)',
    /** Css custom property: --dt-typography-heading-level-1-text-decoration. Default value: none. */
    TextDecoration:
      'var(--dt-typography-heading-level-1-text-decoration, none)',
    /** Css custom property: --dt-typography-heading-level-1-text-transform. Default value: none. */
    TextTransform: 'var(--dt-typography-heading-level-1-text-transform, none)',
  },
  Level2: {
    /** Css custom property: --dt-typography-heading-level-2-family. Default value: DynatraceFlow,Roboto,Helvetica,sans-serif. */
    Family:
      'var(--dt-typography-heading-level-2-family, DynatraceFlow,Roboto,Helvetica,sans-serif)',
    /** Css custom property: --dt-typography-heading-level-2-weight. Default value: 600. */
    Weight: 'var(--dt-typography-heading-level-2-weight, 600)',
    /** Css custom property: --dt-typography-heading-level-2-size. Default value: 28px. */
    Size: 'var(--dt-typography-heading-level-2-size, 28px)',
    /** Css custom property: --dt-typography-heading-level-2-line-height. Default value: 1.2857142857. */
    LineHeight:
      'var(--dt-typography-heading-level-2-line-height, 1.2857142857)',
    /** Css custom property: --dt-typography-heading-level-2-text-decoration. Default value: none. */
    TextDecoration:
      'var(--dt-typography-heading-level-2-text-decoration, none)',
    /** Css custom property: --dt-typography-heading-level-2-text-transform. Default value: none. */
    TextTransform: 'var(--dt-typography-heading-level-2-text-transform, none)',
  },
  Level3: {
    /** Css custom property: --dt-typography-heading-level-3-family. Default value: DynatraceFlow,Roboto,Helvetica,sans-serif. */
    Family:
      'var(--dt-typography-heading-level-3-family, DynatraceFlow,Roboto,Helvetica,sans-serif)',
    /** Css custom property: --dt-typography-heading-level-3-weight. Default value: 600. */
    Weight: 'var(--dt-typography-heading-level-3-weight, 600)',
    /** Css custom property: --dt-typography-heading-level-3-size. Default value: 24px. */
    Size: 'var(--dt-typography-heading-level-3-size, 24px)',
    /** Css custom property: --dt-typography-heading-level-3-line-height. Default value: 1.3333333333. */
    LineHeight:
      'var(--dt-typography-heading-level-3-line-height, 1.3333333333)',
    /** Css custom property: --dt-typography-heading-level-3-text-decoration. Default value: none. */
    TextDecoration:
      'var(--dt-typography-heading-level-3-text-decoration, none)',
    /** Css custom property: --dt-typography-heading-level-3-text-transform. Default value: none. */
    TextTransform: 'var(--dt-typography-heading-level-3-text-transform, none)',
  },
  Level4: {
    /** Css custom property: --dt-typography-heading-level-4-family. Default value: DynatraceFlow,Roboto,Helvetica,sans-serif. */
    Family:
      'var(--dt-typography-heading-level-4-family, DynatraceFlow,Roboto,Helvetica,sans-serif)',
    /** Css custom property: --dt-typography-heading-level-4-weight. Default value: 600. */
    Weight: 'var(--dt-typography-heading-level-4-weight, 600)',
    /** Css custom property: --dt-typography-heading-level-4-size. Default value: 20px. */
    Size: 'var(--dt-typography-heading-level-4-size, 20px)',
    /** Css custom property: --dt-typography-heading-level-4-line-height. Default value: 1.4. */
    LineHeight: 'var(--dt-typography-heading-level-4-line-height, 1.4)',
    /** Css custom property: --dt-typography-heading-level-4-text-decoration. Default value: none. */
    TextDecoration:
      'var(--dt-typography-heading-level-4-text-decoration, none)',
    /** Css custom property: --dt-typography-heading-level-4-text-transform. Default value: none. */
    TextTransform: 'var(--dt-typography-heading-level-4-text-transform, none)',
  },
  Level5: {
    /** Css custom property: --dt-typography-heading-level-5-family. Default value: DynatraceFlow,Roboto,Helvetica,sans-serif. */
    Family:
      'var(--dt-typography-heading-level-5-family, DynatraceFlow,Roboto,Helvetica,sans-serif)',
    /** Css custom property: --dt-typography-heading-level-5-weight. Default value: 600. */
    Weight: 'var(--dt-typography-heading-level-5-weight, 600)',
    /** Css custom property: --dt-typography-heading-level-5-size. Default value: 16px. */
    Size: 'var(--dt-typography-heading-level-5-size, 16px)',
    /** Css custom property: --dt-typography-heading-level-5-line-height. Default value: 1.5. */
    LineHeight: 'var(--dt-typography-heading-level-5-line-height, 1.5)',
    /** Css custom property: --dt-typography-heading-level-5-text-decoration. Default value: none. */
    TextDecoration:
      'var(--dt-typography-heading-level-5-text-decoration, none)',
    /** Css custom property: --dt-typography-heading-level-5-text-transform. Default value: none. */
    TextTransform: 'var(--dt-typography-heading-level-5-text-transform, none)',
  },
  Level6: {
    /** Css custom property: --dt-typography-heading-level-6-family. Default value: DynatraceFlow,Roboto,Helvetica,sans-serif. */
    Family:
      'var(--dt-typography-heading-level-6-family, DynatraceFlow,Roboto,Helvetica,sans-serif)',
    /** Css custom property: --dt-typography-heading-level-6-weight. Default value: 600. */
    Weight: 'var(--dt-typography-heading-level-6-weight, 600)',
    /** Css custom property: --dt-typography-heading-level-6-size. Default value: 14px. */
    Size: 'var(--dt-typography-heading-level-6-size, 14px)',
    /** Css custom property: --dt-typography-heading-level-6-line-height. Default value: 1.4285714286. */
    LineHeight:
      'var(--dt-typography-heading-level-6-line-height, 1.4285714286)',
    /** Css custom property: --dt-typography-heading-level-6-text-decoration. Default value: none. */
    TextDecoration:
      'var(--dt-typography-heading-level-6-text-decoration, none)',
    /** Css custom property: --dt-typography-heading-level-6-text-transform. Default value: none. */
    TextTransform: 'var(--dt-typography-heading-level-6-text-transform, none)',
  },
};
/** Use to provide additional, secondary text to heading and display typography styles. Should only be used in combination with display or heading styles. */
const Subtitle = {
  Display: {
    Level1: {
      /** Css custom property: --dt-typography-subtitle-display-level-1-family. Default value: DynatraceFlow,Roboto,Helvetica,sans-serif. */
      Family:
        'var(--dt-typography-subtitle-display-level-1-family, DynatraceFlow,Roboto,Helvetica,sans-serif)',
      /** Css custom property: --dt-typography-subtitle-display-level-1-weight. Default value: 400. */
      Weight: 'var(--dt-typography-subtitle-display-level-1-weight, 400)',
      /** Css custom property: --dt-typography-subtitle-display-level-1-size. Default value: 28px. */
      Size: 'var(--dt-typography-subtitle-display-level-1-size, 28px)',
      /** Css custom property: --dt-typography-subtitle-display-level-1-line-height. Default value: 1.4285714286. */
      LineHeight:
        'var(--dt-typography-subtitle-display-level-1-line-height, 1.4285714286)',
      /** Css custom property: --dt-typography-subtitle-display-level-1-text-decoration. Default value: none. */
      TextDecoration:
        'var(--dt-typography-subtitle-display-level-1-text-decoration, none)',
      /** Css custom property: --dt-typography-subtitle-display-level-1-text-transform. Default value: none. */
      TextTransform:
        'var(--dt-typography-subtitle-display-level-1-text-transform, none)',
    },
    Level2: {
      /** Css custom property: --dt-typography-subtitle-display-level-2-family. Default value: DynatraceFlow,Roboto,Helvetica,sans-serif. */
      Family:
        'var(--dt-typography-subtitle-display-level-2-family, DynatraceFlow,Roboto,Helvetica,sans-serif)',
      /** Css custom property: --dt-typography-subtitle-display-level-2-weight. Default value: 400. */
      Weight: 'var(--dt-typography-subtitle-display-level-2-weight, 400)',
      /** Css custom property: --dt-typography-subtitle-display-level-2-size. Default value: 24px. */
      Size: 'var(--dt-typography-subtitle-display-level-2-size, 24px)',
      /** Css custom property: --dt-typography-subtitle-display-level-2-line-height. Default value: 1.5. */
      LineHeight:
        'var(--dt-typography-subtitle-display-level-2-line-height, 1.5)',
      /** Css custom property: --dt-typography-subtitle-display-level-2-text-decoration. Default value: none. */
      TextDecoration:
        'var(--dt-typography-subtitle-display-level-2-text-decoration, none)',
      /** Css custom property: --dt-typography-subtitle-display-level-2-text-transform. Default value: none. */
      TextTransform:
        'var(--dt-typography-subtitle-display-level-2-text-transform, none)',
    },
    Level3: {
      /** Css custom property: --dt-typography-subtitle-display-level-3-family. Default value: DynatraceFlow,Roboto,Helvetica,sans-serif. */
      Family:
        'var(--dt-typography-subtitle-display-level-3-family, DynatraceFlow,Roboto,Helvetica,sans-serif)',
      /** Css custom property: --dt-typography-subtitle-display-level-3-weight. Default value: 400. */
      Weight: 'var(--dt-typography-subtitle-display-level-3-weight, 400)',
      /** Css custom property: --dt-typography-subtitle-display-level-3-size. Default value: 21px. */
      Size: 'var(--dt-typography-subtitle-display-level-3-size, 21px)',
      /** Css custom property: --dt-typography-subtitle-display-level-3-line-height. Default value: 1.5238095238. */
      LineHeight:
        'var(--dt-typography-subtitle-display-level-3-line-height, 1.5238095238)',
      /** Css custom property: --dt-typography-subtitle-display-level-3-text-decoration. Default value: none. */
      TextDecoration:
        'var(--dt-typography-subtitle-display-level-3-text-decoration, none)',
      /** Css custom property: --dt-typography-subtitle-display-level-3-text-transform. Default value: none. */
      TextTransform:
        'var(--dt-typography-subtitle-display-level-3-text-transform, none)',
    },
  },
  Heading: {
    Level1: {
      /** Css custom property: --dt-typography-subtitle-heading-level-1-family. Default value: DynatraceFlow,Roboto,Helvetica,sans-serif. */
      Family:
        'var(--dt-typography-subtitle-heading-level-1-family, DynatraceFlow,Roboto,Helvetica,sans-serif)',
      /** Css custom property: --dt-typography-subtitle-heading-level-1-weight. Default value: 400. */
      Weight: 'var(--dt-typography-subtitle-heading-level-1-weight, 400)',
      /** Css custom property: --dt-typography-subtitle-heading-level-1-size. Default value: 21px. */
      Size: 'var(--dt-typography-subtitle-heading-level-1-size, 21px)',
      /** Css custom property: --dt-typography-subtitle-heading-level-1-line-height. Default value: 1.5238095238. */
      LineHeight:
        'var(--dt-typography-subtitle-heading-level-1-line-height, 1.5238095238)',
      /** Css custom property: --dt-typography-subtitle-heading-level-1-text-decoration. Default value: none. */
      TextDecoration:
        'var(--dt-typography-subtitle-heading-level-1-text-decoration, none)',
      /** Css custom property: --dt-typography-subtitle-heading-level-1-text-transform. Default value: none. */
      TextTransform:
        'var(--dt-typography-subtitle-heading-level-1-text-transform, none)',
    },
    Level2: {
      /** Css custom property: --dt-typography-subtitle-heading-level-2-family. Default value: DynatraceFlow,Roboto,Helvetica,sans-serif. */
      Family:
        'var(--dt-typography-subtitle-heading-level-2-family, DynatraceFlow,Roboto,Helvetica,sans-serif)',
      /** Css custom property: --dt-typography-subtitle-heading-level-2-weight. Default value: 400. */
      Weight: 'var(--dt-typography-subtitle-heading-level-2-weight, 400)',
      /** Css custom property: --dt-typography-subtitle-heading-level-2-size. Default value: 18px. */
      Size: 'var(--dt-typography-subtitle-heading-level-2-size, 18px)',
      /** Css custom property: --dt-typography-subtitle-heading-level-2-line-height. Default value: 1.5555555556. */
      LineHeight:
        'var(--dt-typography-subtitle-heading-level-2-line-height, 1.5555555556)',
      /** Css custom property: --dt-typography-subtitle-heading-level-2-text-decoration. Default value: none. */
      TextDecoration:
        'var(--dt-typography-subtitle-heading-level-2-text-decoration, none)',
      /** Css custom property: --dt-typography-subtitle-heading-level-2-text-transform. Default value: none. */
      TextTransform:
        'var(--dt-typography-subtitle-heading-level-2-text-transform, none)',
    },
    Level3: {
      /** Css custom property: --dt-typography-subtitle-heading-level-3-family. Default value: DynatraceFlow,Roboto,Helvetica,sans-serif. */
      Family:
        'var(--dt-typography-subtitle-heading-level-3-family, DynatraceFlow,Roboto,Helvetica,sans-serif)',
      /** Css custom property: --dt-typography-subtitle-heading-level-3-weight. Default value: 400. */
      Weight: 'var(--dt-typography-subtitle-heading-level-3-weight, 400)',
      /** Css custom property: --dt-typography-subtitle-heading-level-3-size. Default value: 16px. */
      Size: 'var(--dt-typography-subtitle-heading-level-3-size, 16px)',
      /** Css custom property: --dt-typography-subtitle-heading-level-3-line-height. Default value: 1.5. */
      LineHeight:
        'var(--dt-typography-subtitle-heading-level-3-line-height, 1.5)',
      /** Css custom property: --dt-typography-subtitle-heading-level-3-text-decoration. Default value: none. */
      TextDecoration:
        'var(--dt-typography-subtitle-heading-level-3-text-decoration, none)',
      /** Css custom property: --dt-typography-subtitle-heading-level-3-text-transform. Default value: none. */
      TextTransform:
        'var(--dt-typography-subtitle-heading-level-3-text-transform, none)',
    },
  },
};
/** Used for default body text. */
const Text = {
  Base: {
    /** Use to style the main body text of the interface. Legible and comfortable for extended reading. */
    Default: {
      /** Css custom property: --dt-typography-text-base-default-family. Default value: DynatraceFlow,Roboto,Helvetica,sans-serif. */
      Family:
        'var(--dt-typography-text-base-default-family, DynatraceFlow,Roboto,Helvetica,sans-serif)',
      /** Css custom property: --dt-typography-text-base-default-weight. Default value: 400. */
      Weight: 'var(--dt-typography-text-base-default-weight, 400)',
      /** Css custom property: --dt-typography-text-base-default-size. Default value: 14px. */
      Size: 'var(--dt-typography-text-base-default-size, 14px)',
      /** Css custom property: --dt-typography-text-base-default-line-height. Default value: 1.4285714286. */
      LineHeight:
        'var(--dt-typography-text-base-default-line-height, 1.4285714286)',
      /** Css custom property: --dt-typography-text-base-default-text-decoration. Default value: none. */
      TextDecoration:
        'var(--dt-typography-text-base-default-text-decoration, none)',
      /** Css custom property: --dt-typography-text-base-default-text-transform. Default value: none. */
      TextTransform:
        'var(--dt-typography-text-base-default-text-transform, none)',
    },
    /** Use to style short-form text in the interface that requires additional emphasis or attention. Conveys a stronger tone in relation to the default text style. */
    Emphasized: {
      /** Css custom property: --dt-typography-text-base-emphasized-family. Default value: DynatraceFlow,Roboto,Helvetica,sans-serif. */
      Family:
        'var(--dt-typography-text-base-emphasized-family, DynatraceFlow,Roboto,Helvetica,sans-serif)',
      /** Css custom property: --dt-typography-text-base-emphasized-weight. Default value: 500. */
      Weight: 'var(--dt-typography-text-base-emphasized-weight, 500)',
      /** Css custom property: --dt-typography-text-base-emphasized-size. Default value: 14px. */
      Size: 'var(--dt-typography-text-base-emphasized-size, 14px)',
      /** Css custom property: --dt-typography-text-base-emphasized-line-height. Default value: 1.4285714286. */
      LineHeight:
        'var(--dt-typography-text-base-emphasized-line-height, 1.4285714286)',
      /** Css custom property: --dt-typography-text-base-emphasized-text-decoration. Default value: none. */
      TextDecoration:
        'var(--dt-typography-text-base-emphasized-text-decoration, none)',
      /** Css custom property: --dt-typography-text-base-emphasized-text-transform. Default value: none. */
      TextTransform:
        'var(--dt-typography-text-base-emphasized-text-transform, none)',
    },
  },
  Small: {
    /** Use to display text in a lower hierarchy than the base text style. */
    Default: {
      /** Css custom property: --dt-typography-text-small-default-family. Default value: DynatraceFlow,Roboto,Helvetica,sans-serif. */
      Family:
        'var(--dt-typography-text-small-default-family, DynatraceFlow,Roboto,Helvetica,sans-serif)',
      /** Css custom property: --dt-typography-text-small-default-weight. Default value: 400. */
      Weight: 'var(--dt-typography-text-small-default-weight, 400)',
      /** Css custom property: --dt-typography-text-small-default-size. Default value: 12px. */
      Size: 'var(--dt-typography-text-small-default-size, 12px)',
      /** Css custom property: --dt-typography-text-small-default-line-height. Default value: 1.333333333. */
      LineHeight:
        'var(--dt-typography-text-small-default-line-height, 1.333333333)',
      /** Css custom property: --dt-typography-text-small-default-text-decoration. Default value: none. */
      TextDecoration:
        'var(--dt-typography-text-small-default-text-decoration, none)',
      /** Css custom property: --dt-typography-text-small-default-text-transform. Default value: none. */
      TextTransform:
        'var(--dt-typography-text-small-default-text-transform, none)',
    },
    /** Use to add a tone that conveys importance in relation to the default text style. */
    Emphasized: {
      /** Css custom property: --dt-typography-text-small-emphasized-family. Default value: DynatraceFlow,Roboto,Helvetica,sans-serif. */
      Family:
        'var(--dt-typography-text-small-emphasized-family, DynatraceFlow,Roboto,Helvetica,sans-serif)',
      /** Css custom property: --dt-typography-text-small-emphasized-weight. Default value: 500. */
      Weight: 'var(--dt-typography-text-small-emphasized-weight, 500)',
      /** Css custom property: --dt-typography-text-small-emphasized-size. Default value: 12px. */
      Size: 'var(--dt-typography-text-small-emphasized-size, 12px)',
      /** Css custom property: --dt-typography-text-small-emphasized-line-height. Default value: 1.333333333. */
      LineHeight:
        'var(--dt-typography-text-small-emphasized-line-height, 1.333333333)',
      /** Css custom property: --dt-typography-text-small-emphasized-text-decoration. Default value: none. */
      TextDecoration:
        'var(--dt-typography-text-small-emphasized-text-decoration, none)',
      /** Css custom property: --dt-typography-text-small-emphasized-text-transform. Default value: none. */
      TextTransform:
        'var(--dt-typography-text-small-emphasized-text-transform, none)',
    },
  },
};
/** Use to display text in a monospace font, such as code snippets, terminal commands, or data. */
const Code = {
  Base: {
    /** Use to display text in code. */
    Default: {
      /** Css custom property: --dt-typography-code-base-default-family. Default value: Roboto Mono,monospace. */
      Family:
        'var(--dt-typography-code-base-default-family, Roboto Mono,monospace)',
      /** Css custom property: --dt-typography-code-base-default-weight. Default value: 400. */
      Weight: 'var(--dt-typography-code-base-default-weight, 400)',
      /** Css custom property: --dt-typography-code-base-default-size. Default value: 14px. */
      Size: 'var(--dt-typography-code-base-default-size, 14px)',
      /** Css custom property: --dt-typography-code-base-default-line-height. Default value: 1.4285714286. */
      LineHeight:
        'var(--dt-typography-code-base-default-line-height, 1.4285714286)',
      /** Css custom property: --dt-typography-code-base-default-text-decoration. Default value: none. */
      TextDecoration:
        'var(--dt-typography-code-base-default-text-decoration, none)',
      /** Css custom property: --dt-typography-code-base-default-text-transform. Default value: none. */
      TextTransform:
        'var(--dt-typography-code-base-default-text-transform, none)',
    },
    /** Use to add a tone that conveys importance in relation to the default text style. */
    Emphasized: {
      /** Css custom property: --dt-typography-code-base-emphasized-family. Default value: Roboto Mono,monospace. */
      Family:
        'var(--dt-typography-code-base-emphasized-family, Roboto Mono,monospace)',
      /** Css custom property: --dt-typography-code-base-emphasized-weight. Default value: 500. */
      Weight: 'var(--dt-typography-code-base-emphasized-weight, 500)',
      /** Css custom property: --dt-typography-code-base-emphasized-size. Default value: 14px. */
      Size: 'var(--dt-typography-code-base-emphasized-size, 14px)',
      /** Css custom property: --dt-typography-code-base-emphasized-line-height. Default value: 1.4285714286. */
      LineHeight:
        'var(--dt-typography-code-base-emphasized-line-height, 1.4285714286)',
      /** Css custom property: --dt-typography-code-base-emphasized-text-decoration. Default value: none. */
      TextDecoration:
        'var(--dt-typography-code-base-emphasized-text-decoration, none)',
      /** Css custom property: --dt-typography-code-base-emphasized-text-transform. Default value: none. */
      TextTransform:
        'var(--dt-typography-code-base-emphasized-text-transform, none)',
    },
  },
  Small: {
    /** Use to display code in a more space-efficient variant in relation to the base text style. */
    Default: {
      /** Css custom property: --dt-typography-code-small-default-family. Default value: Roboto Mono,monospace. */
      Family:
        'var(--dt-typography-code-small-default-family, Roboto Mono,monospace)',
      /** Css custom property: --dt-typography-code-small-default-weight. Default value: 400. */
      Weight: 'var(--dt-typography-code-small-default-weight, 400)',
      /** Css custom property: --dt-typography-code-small-default-size. Default value: 12px. */
      Size: 'var(--dt-typography-code-small-default-size, 12px)',
      /** Css custom property: --dt-typography-code-small-default-line-height. Default value: 1.333333333. */
      LineHeight:
        'var(--dt-typography-code-small-default-line-height, 1.333333333)',
      /** Css custom property: --dt-typography-code-small-default-text-decoration. Default value: none. */
      TextDecoration:
        'var(--dt-typography-code-small-default-text-decoration, none)',
      /** Css custom property: --dt-typography-code-small-default-text-transform. Default value: none. */
      TextTransform:
        'var(--dt-typography-code-small-default-text-transform, none)',
    },
    /** Use to add a tone that conveys interactivity or importance in relation to the default text style. */
    Emphasized: {
      /** Css custom property: --dt-typography-code-small-emphasized-family. Default value: Roboto Mono,monospace. */
      Family:
        'var(--dt-typography-code-small-emphasized-family, Roboto Mono,monospace)',
      /** Css custom property: --dt-typography-code-small-emphasized-weight. Default value: 500. */
      Weight: 'var(--dt-typography-code-small-emphasized-weight, 500)',
      /** Css custom property: --dt-typography-code-small-emphasized-size. Default value: 12px. */
      Size: 'var(--dt-typography-code-small-emphasized-size, 12px)',
      /** Css custom property: --dt-typography-code-small-emphasized-line-height. Default value: 1.333333333. */
      LineHeight:
        'var(--dt-typography-code-small-emphasized-line-height, 1.333333333)',
      /** Css custom property: --dt-typography-code-small-emphasized-text-decoration. Default value: none. */
      TextDecoration:
        'var(--dt-typography-code-small-emphasized-text-decoration, none)',
      /** Css custom property: --dt-typography-code-small-emphasized-text-transform. Default value: none. */
      TextTransform:
        'var(--dt-typography-code-small-emphasized-text-transform, none)',
    },
  },
};
export default {
  Display,
  Heading,
  Subtitle,
  Text,
  Code,
};
